import { ModalSelector } from "components/ModalSelector";
import { WalletCard } from "components/WalletCard";
import { filterCurrencies } from "utils/filters";
import { useIntl } from "react-intl";
import { messages } from "./messages";
import { MultiCurrencyPickerProps } from "./types";
import { HubCurrencies } from "@letsbit/malcolmlb";
import { Input } from "@letsbit/milkylb";
// import { ReactComponent as SimpleArrowIcon } from "assets/images/icons/simple-arrow.svg";

export const WalletCardWrapper: React.FC<{
  element: HubCurrencies & { selected?: boolean };
}> = ({ element: { selected, ...rest } }) => {
  return (
    <WalletCard
      element={rest}
      classname={selected ? "border-2 border-purple-400" : undefined}
    />
  );
};

export const MultiCurrencyPicker: React.FC<MultiCurrencyPickerProps> = ({
  title,
  currencies,
  onSelectCurrencies,
  selectedCurrencies,
  dataCypressId,
}) => {
  const options = currencies?.map((c) => ({
    ...c,
    selected: selectedCurrencies?.has(c.id),
  }));
  const { formatMessage } = useIntl();
  return (
    <ModalSelector
      title={title}
      filter={filterCurrencies}
      optionComponent={WalletCardWrapper}
      options={options}
      closeOnSelect={false}
      onSelectOption={(c) => {
        if (c.selected && selectedCurrencies) {
          selectedCurrencies.delete(c.id);
          onSelectCurrencies(selectedCurrencies);
        } else if (selectedCurrencies) {
          selectedCurrencies.add(c.id);
          onSelectCurrencies(selectedCurrencies);
        }
      }}
    >
      {({ onClick }) => {
        return (
          <Input
            onClick={onClick}
            data-cypress-id={dataCypressId}
            value={
              selectedCurrencies &&
              Array.from(selectedCurrencies.values())
                .map((currency, index, array) => {
                  const ticker_id = currencies?.find(
                    (c) => c.id === currency,
                  )?.ticker_id;
                  if (index === array.length - 1) {
                    return ticker_id?.toUpperCase();
                  } else if (index === array.length - 2) {
                    return `${ticker_id?.toUpperCase()} y`;
                  } else {
                    return `${ticker_id?.toUpperCase()},`;
                  }
                })
                .join(" ")
            }
            placeholder={formatMessage(messages.selectLabel)}
            labelPlacement="floating"
          />
        );
      }}
    </ModalSelector>
  );
};
